module.exports = "/fast-coin/img/coin/anim/shine_1/shine_1_028.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/shine_1/shine_1_028.png
// module id = 2344
// module chunks = 5